import axios from 'axios'
import loginData from 'utilities/loginData'
import handleDates from './handleDates'

const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})
apiClient.interceptors.request.use((config) => {
  if (loginData.isLoggedIn()) {
    config.headers['x-aqc-token'] = loginData.getToken()
  }
  return config
})
apiClient.interceptors.response.use(
  (response) => {
    if (response.data) {
      response.data = handleDates(response.data)
    }
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/login'
    }
    if (error.response?.status === 503) {
      window.location.href = '/maintenance'
    }
    return Promise.reject(error)
  },
)

export default apiClient
